import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import TextField from '@mui/material/TextField';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Button from '@mui/material/Button';
import { WrapperFilter, WrapperRegion, WrapperGroup, WrapperService, WrapperPeriodicity, WrapperInput } from './styles';

const Index = ({ component }) => {
  const dispatch = useDispatch();
  
  const dataFilter = useSelector((state) => state.fuse?.filter?.filter);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, values, index, ...other } = props;

    return (
      <div role="tabpanel" hidden={values !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
        {values === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <div className="flex flex-col max-w-full gap-0 bg-white rounded-lg p-10">
        <WrapperInput>
          <div>
            <h4 className="subtitle-input">Filtrar por:</h4>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                display: 'flex',
                justifyContent: 'space-evenly',
                margin: '20px 20px 0px 20px',
              }}
            >
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab icon={<DomainVerificationIcon />} aria-label="total" {...a11yProps(0)} />
                <Tab icon={<CalendarMonthIcon />} aria-label="date" {...a11yProps(1)} />
                <Tab icon={<QueryBuilderIcon />} aria-label="time" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0} sx={{ textAlign: 'center' }}>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Tiempo Real
              </InputLabel>
              <DesktopDatePicker
                // value={value}
                // onChange={handleChange}
                renderInput={(params) => (
                  <TextField
                    style={{
                      width: '98%',
                      margin: '2% 2% 2% 0%',
                    }}
                    {...params}
                  />
                )}
                fullWidth
                disabled
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Inicio:
              </InputLabel>
              <DesktopDatePicker
                // value={value}
                // onChange={handleChange}
                renderInput={(params) => (
                  <TextField
                    style={{
                      width: '98%',
                      margin: '2% 2% 2% 0%',
                    }}
                    {...params}
                  />
                )}
                fullWidth
              />
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Fin:
              </InputLabel>
              <DesktopDatePicker
                // value={value}
                // onChange={handleChange}
                renderInput={(params) => (
                  <TextField
                    style={{
                      width: '98%',
                      margin: '2% 2% 2% 0%',
                    }}
                    {...params}
                  />
                )}
                fullWidth
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Inicio:
              </InputLabel>
              <TimePicker
                // value={value}
                // onChange={handleChange}
                renderInput={(params) => (
                  <TextField
                    style={{
                      width: '98%',
                      margin: '2% 2% 2% 0%',
                    }}
                    {...params}
                  />
                )}
              />
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Fin:
              </InputLabel>
              <TimePicker
                // value={value}
                // onChange={handleChange}
                renderInput={(params) => (
                  <TextField
                    style={{
                      width: '98%',
                      margin: '2% 2% 2% 0%',
                    }}
                    {...params}
                  />
                )}
              />
            </TabPanel>
          </div>
        </WrapperInput>
        <WrapperFilter>
          <h4 className="title-filter">Filtros</h4>
          {dataFilter?.region?.components?.includes(component) && (
            <WrapperRegion>
              <h4 className="subtitle-filter">Región</h4>
              {dataFilter?.region?.data?.map((data, index) => (
                <FormGroup key={index}>
                  <FormControlLabel control={<Checkbox />} label={data.name} />
                </FormGroup>
              ))}
            </WrapperRegion>
          )}
          {dataFilter?.group?.components?.includes(component) && (
            <WrapperGroup>
              <h4 className="subtitle-filter">Grupo</h4>
              {dataFilter?.group?.data?.map((data, index) => (
                <FormGroup key={index}>
                  <FormControlLabel control={<Checkbox />} label={data.name} />
                </FormGroup>
              ))}
            </WrapperGroup>
          )}
          {dataFilter?.nivelesServicio?.components?.includes(component) && (
            <WrapperService>
              <h4 className="subtitle-filter">Niveles de servicio</h4>
              {dataFilter?.nivelesServicio?.data?.map((data, index) => (
                <FormGroup key={index}>
                  <FormControlLabel control={<Checkbox />} label={data.name} />
                </FormGroup>
              ))}
            </WrapperService>
          )}
          {dataFilter?.periocidad?.components?.includes(component) && (
            <WrapperPeriodicity>
              <h4 className="subtitle-filter">Periociddad</h4>
              {dataFilter?.periocidad?.data?.map((data, index) => (
                <FormGroup key={index}>
                  <FormControlLabel control={<Checkbox />} label={data.name} />
                </FormGroup>
              ))}
            </WrapperPeriodicity>
          )}
          <WrapperInput>
            <div>
              <h4 className="subtitle-input">Inmueble</h4>
              <FormControl
                style={{
                  width: '100%',
                  marginTop: '15px',
                }}
              >
                <InputLabel htmlFor="my-input">Selecciona el Inmueble</InputLabel>
                <Select labelId="inmueble" id="demo-simple-select" label="inmueble">
                  <MenuItem value={1}>Inmueble 1</MenuItem>
                  <MenuItem value={2}>Inmueble 2</MenuItem>
                  <MenuItem value={3}>Inmueble 3</MenuItem>
                  <MenuItem value={4}>Inmueble 4</MenuItem>
                </Select>
              </FormControl>
            </div>
          </WrapperInput>
          <Button variant="contained" color="success" style={{ marginTop: '5rem' }}>Buscar</Button>
        </WrapperFilter>
      </div>
    </>
  );
};

export default Index;
